/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PurchaseRateIssueDTO interface.
 */
export function instanceOfPurchaseRateIssueDTO(value) {
    return true;
}
export function PurchaseRateIssueDTOFromJSON(json) {
    return PurchaseRateIssueDTOFromJSONTyped(json, false);
}
export function PurchaseRateIssueDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'carrier': json['carrier'] == null ? undefined : json['carrier'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}
export function PurchaseRateIssueDTOToJSON(json) {
    return PurchaseRateIssueDTOToJSONTyped(json, false);
}
export function PurchaseRateIssueDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'carrier': value['carrier'],
        'reason': value['reason'],
    };
}
